const pointto = {
    state: {
        pointtostate: 0
    },
    mutations: {
        POINTTO: (state, data) => {
            state.pointtostate = data
        },
    },
    actions: {
        pointto({ commit }, data) {
            commit('POINTTO', data)
        },
    }
}
export default pointto


// WEBPACK FOOTER //
// ./src/store/modules/covidJump.js